/* __next_internal_client_entry_do_not_use__ UnitedStates auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=13%3A370))
 * @trackcomponent
 * @lastsynced 2023-11-30T15:50:25.889Z
 */ export var UnitedStates = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("rect", {
            x: "1",
            y: "1",
            width: "16",
            height: "12",
            fill: "white",
            stroke: "#757575"
        }),
        /*#__PURE__*/ _jsx("rect", {
            x: "8",
            y: "1.5",
            width: "9",
            height: "1",
            fill: "#B64343"
        }),
        /*#__PURE__*/ _jsx("rect", {
            x: "1",
            y: "3.5",
            width: "16",
            height: "1",
            fill: "#B64343"
        }),
        /*#__PURE__*/ _jsx("rect", {
            x: "1",
            y: "5.5",
            width: "16",
            height: "1",
            fill: "#B64343"
        }),
        /*#__PURE__*/ _jsx("rect", {
            x: "1",
            y: "7.5",
            width: "16",
            height: "1",
            fill: "#B64343"
        }),
        /*#__PURE__*/ _jsx("rect", {
            x: "1",
            y: "9.5",
            width: "16",
            height: "1",
            fill: "#B64343"
        }),
        /*#__PURE__*/ _jsx("rect", {
            x: "1",
            y: "11.5",
            width: "16",
            height: "1",
            fill: "#B64343"
        }),
        /*#__PURE__*/ _jsx("rect", {
            x: "1",
            y: "1",
            width: "7",
            height: "5.5",
            fill: "#354992"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M4.59375 2.9375L4.73151 3.21664L5.03956 3.2614L4.81665 3.47868L4.86927 3.78548L4.59375 3.64062L4.31823 3.78548L4.37085 3.47868L4.14794 3.2614L4.45599 3.21664L4.59375 2.9375Z",
            fill: "white"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M2.71875 2.9375L2.85651 3.21664L3.16456 3.2614L2.94165 3.47868L2.99427 3.78548L2.71875 3.64062L2.44323 3.78548L2.49585 3.47868L2.27294 3.2614L2.58099 3.21664L2.71875 2.9375Z",
            fill: "white"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M3.65625 2L3.79401 2.27914L4.10206 2.3239L3.87915 2.54118L3.93177 2.84798L3.65625 2.70312L3.38073 2.84798L3.43335 2.54118L3.21044 2.3239L3.51849 2.27914L3.65625 2Z",
            fill: "white"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M3.65625 3.875L3.79401 4.15414L4.10206 4.1989L3.87915 4.41618L3.93177 4.72298L3.65625 4.57812L3.38073 4.72298L3.43335 4.41618L3.21044 4.1989L3.51849 4.15414L3.65625 3.875Z",
            fill: "white"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M6.46875 2.9375L6.60651 3.21664L6.91456 3.2614L6.69165 3.47868L6.74427 3.78548L6.46875 3.64062L6.19323 3.78548L6.24585 3.47868L6.02294 3.2614L6.33099 3.21664L6.46875 2.9375Z",
            fill: "white"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M5.53125 3.875L5.66901 4.15414L5.97706 4.1989L5.75415 4.41618L5.80677 4.72298L5.53125 4.57812L5.25573 4.72298L5.30835 4.41618L5.08544 4.1989L5.39349 4.15414L5.53125 3.875Z",
            fill: "white"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M6.46875 4.8125L6.60651 5.09164L6.91456 5.1364L6.69165 5.35368L6.74427 5.66048L6.46875 5.51562L6.19323 5.66048L6.24585 5.35368L6.02294 5.1364L6.33099 5.09164L6.46875 4.8125Z",
            fill: "white"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M5.53125 2L5.66901 2.27914L5.97706 2.3239L5.75415 2.54118L5.80677 2.84798L5.53125 2.70312L5.25573 2.84798L5.30835 2.54118L5.08544 2.3239L5.39349 2.27914L5.53125 2Z",
            fill: "white"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M4.59375 4.8125L4.73151 5.09164L5.03956 5.1364L4.81665 5.35368L4.86927 5.66048L4.59375 5.51562L4.31823 5.66048L4.37085 5.35368L4.14794 5.1364L4.45599 5.09164L4.59375 4.8125Z",
            fill: "white"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M2.71875 4.8125L2.85651 5.09164L3.16456 5.1364L2.94165 5.35368L2.99427 5.66048L2.71875 5.51562L2.44323 5.66048L2.49585 5.35368L2.27294 5.1364L2.58099 5.09164L2.71875 4.8125Z",
            fill: "white"
        }),
        /*#__PURE__*/ _jsx("rect", {
            x: "1",
            y: "1",
            width: "16",
            height: "12",
            stroke: "#757575"
        })
    ]
}), "UnitedStates", function(strictLocalize) {
    return {
        viewBox: "0 0 18 14",
        fill: "none",
        titleAccess: strictLocalize({
            id: "gbiBlz",
            defaultMessage: [
                {
                    type: 0,
                    value: "United States flag"
                }
            ]
        })
    };
});
